<template>
  <v-dialog v-model="targetDialog" max-width="800" persistent scrollable>
    <v-card>
      <v-card-title class="text-h5 grey lighten-4">
        <v-card flat width="300" color="transparent">用語の説明</v-card>

        <div class="d-sm-none my-2">
          <v-select
            v-model="tab"
            :items="tabItems"
            item-text="name"
            item-value="tab"
            label="選択"
            outlined
            dense
            width="160"
            hide-details
          />
        </div>
        <div class="d-none d-sm-flex my-2 flex-wrap">
          <v-btn
            v-for="item in tabItems"
            :key="item.tab"
            class="mr-1 mb-1 px-2"
            :outlined="tab !== item.tab"
            :color="tab === item.tab ? 'primary' : 'indigo'"
            @click="tab = item.tab"
            >{{ item.name }}</v-btn
          >
        </div>
      </v-card-title>
      <v-card-text class="pt-3" ref="dialogContent">
        <v-card max-width="800" flat class="mt-3 glossary-content">
          <div v-if="tab === 'manhole'">
            <span>地図上の</span>
            <v-icon color="#26A69A">mdi-alpha-m-circle</v-icon>
            <span>
              のマークをクリックすると、管路内で観測した水位をリアルタイムで確認できます。
              観測水位が上昇し、内水氾濫の危険が迫っているときに、以下の基準でマークの色が変更します。
            </span>
            <br /><br />
            <div class="d-flex align-center">
              <div>注意水位</div>
              <v-icon color="#FF9800">mdi-alpha-m-circle</v-icon>
            </div>
            <div class="ml-2 mb-2">
              管底の高さから道路面の高さまでのうち、5割の水位に達した時
            </div>
            <div class="d-flex align-center">
              <div>危険水位</div>
              <v-icon color="#7B1FA2">mdi-alpha-m-circle</v-icon>
            </div>
            <div class="ml-2">
              管底の高さから道路面の高さまでのうち、8割の水位に達した時
            </div>
            <v-img
              :src="manholeImage"
              @click="openImage(manholeImage)"
              contain
              max-width="400"
              key="manholeImage"
            /><br />
          </div>

          <div v-if="tab === 'suijin'">
            <div class="mb-5">
              <span>地図上の</span>
              <v-icon color="#cddc39">mdi-alpha-s-circle</v-icon>
              <span>
                のマークをクリックすると、道路・水路で検知した冠水情報をリアルタイムで確認できます。
              </span>
            </div>

            <div class="font-weight-bold mb-2">① 道路上の浸水センサ</div>
            <div class="d-flex align-center">
              <div>浸水検知</div>
              <v-icon color="#ad02ad">mdi-alpha-s-circle</v-icon>
            </div>
            <div class="ml-4">
              道路上に冠水が発生し、センサー設置の高さまで水位が到達した場合、マークの色が変わり、グラフ上に冠水状況が表示されます。
            </div>
            <div class="mb-5">
              <v-img
                :src="suijinImage1"
                @click="openImage(suijinImage1)"
                contain
                max-width="300"
                key="suijinImage1"
              />
            </div>

            <div class="font-weight-bold mb-2">
              ② 水路内の浸水センサ（地金堀）
            </div>
            <div class="d-flex align-center">
              <div>浸水注意</div>
              <v-icon color="#ffd600">mdi-alpha-s-circle</v-icon>
            </div>
            <div class="ml-4 mb-2">
              水路内水位が上昇し、浸水注意ラインの高さまで水位が到達した場合、マークの色が変わり、グラフ上に水位状況が表示されます。
            </div>
            <div class="d-flex align-center">
              <div>浸水検知</div>
              <v-icon color="#ad02ad">mdi-alpha-s-circle</v-icon>
            </div>
            <div class="ml-4">
              水路内水位が上昇し、浸水検知ラインの高さまで水位が到達した場合、マークの色が変わり、グラフ上に水位状況が表示されます。なお、このラインを超えると水路に隣接する道路で冠水が発生する恐れがあります。
            </div>
            <div class="mb-5">
              <v-img
                :src="suijinImage2"
                @click="openImage(suijinImage2)"
                contain
                max-width="300"
                key="suijinImage2"
              />
            </div>
            <div
              class="red--text text--red-darken-4 text-decoration-underline font-weight-bold"
            >
              なお、浸水センサーは設置高さに水が到達したことを知らせるもので、水位の深さを測定するものではありません。このため、浸水が検知された際には、グラフ上に表示される浸水検知ラインよりも実際の水位がかなり高い位置まで到達している可能性もありますので、十分ご注意ください。
            </div>
          </div>

          <div v-if="tab === 'rain'">
            本情報は、気象庁の以下の最新情報を合わせて作成しています。<br /><br />
            ・高解像度降水ナウキャスト(～60分先)<br />
            ・降水短時間予報(1～6時間先)<br />
            ・メソ数値予報モデルGPV(MSM) (7～36時間先)<br /><br />
            60分先までは瞬間的な降雨強度を表示し、以降は前1時間の平均降雨強度を表示しています。このため雨域の見え方が異なります。<br />
            なお「メソ数値予報モデルGPV」の雨量は、5kmグリッドの数値予報モデルの結果をそのまま表示しています。局所的な豪雨の表現が難しい、系統誤差の補正がされていない等のモデル特性を十分にご理解の上ご利用下さい。
          </div>

          <div v-if="tab === 'riverFlooding'">
            水路やマンホールから水が溢れる可能性のあるエリアをリアルタイムで表示しています。<br /><br />
            １時間以内程度の豪雨現象による内水現象を対象に、気象庁高解像度降水ナウキャストおよび地形モデルを組み合わせて、内水の発生の恐れがあるエリア（リスクエリア）を解析・予測しています。
            なお本情報は、数時間続く豪雨を原因とする、河川からの越水氾濫は考慮しておりません。<br /><br />
            実況雨量に基づく「現在内水の恐れがあるエリア」、および1時間先までの予測雨量に基づいた「今後内水の恐れがあるエリア」を表示しています。<br /><br />
            また、リスクエリアによる内水の恐れがあるエリアと実際の内水エリアは完全に整合は取れておりません。
            ご覧になる場合はこれらの特性を十分にご理解の上、ご利用ください。<br /><br />
            なお本情報は、(株)建設技術研究所が独自に解析・予測を行っています。ご利用の際は、合わせて気象庁の大雨・洪水(内水害)の警報にも十分注意してください。<br /><br />
            ■「内水の恐れ」の説明<br />
            「内水の恐れ」は、３段階(赤、黄、青)に分けて表示し、赤色になるほど、内水の恐れが高いメッシュを表しています。(内水の深さを表す指標ではありません。)<br /><br />
            <div class="d-flex">
              <v-chip class="mr-2" label color="#fd2100" dark>危険</v-chip>
              <div>周辺で内水が発生している危険性が高い</div>
            </div>
            <div class="d-flex">
              <v-chip class="mr-2" label color="#fbf43c">警戒</v-chip>
              <div>周辺で内水が発生する恐れがある</div>
            </div>
            <div class="d-flex">
              <v-chip class="mr-2" label color="#2595fd">注意</v-chip>
              <div>今後の雨の降り方に注意</div>
            </div>
          </div>

          <div v-if="tab === 'dosya'">
            土砂キキクル（大雨警報(土砂災害)の危険度分布）は、大雨による土砂災害発生の危険度の高まりを、地図上で5段階に色分けして示す情報です。
            常時10分毎に更新しており、土砂災害警戒情報や大雨警報（土砂災害）等が発表されたときに、どこで危険度が高まっているかを把握することができます。避難にかかる時間を考慮して、危険度の判定には2時間先までの雨量及び土壌雨量指数の予測値を用いています。<br /><br />
            土砂災害発生の危険度が高まっている領域にお住まいの方は、土砂災害警戒区域等の外の少しでも安全な場所への早めの避難を心がけてください。<br /><br />
            ■ 危険度の色と避難行動<br />
            <v-img
              :src="dosyaImage"
              @click="openImage(dosyaImage)"
              contain
              key="dosyaimage"
            /><br />
            ※１土砂キキクルに関わらず、自治体から避難情報が発令された場合には速やかに避難行動をとること。<br />
            ※２災害が発生・切迫している状況を市町村が必ず把握することができるとは限らないこと等から、緊急安全確保は必ず発令される情報ではない。また、警戒レベル５相当情報が出たからといって、必ず緊急安全確保が発令されるわけではない。
            <div class="text-right">出典：気象庁ホームページ</div>
          </div>

          <div v-if="tab === 'kouzui'">
            洪水キキクル（洪水警報の危険度分布）は、大雨による中小河川（水位周知河川及びその他河川）の洪水災害発生の危険度の高まりを５段階に色分けして地図上に示したものです。
            危険度の判定には３時間先までの流域雨量指数の予測値を用いており、中小河川の特徴である急激な増水による危険度の高まりを事前に確認することができます。
            また、大河川で洪水のおそれがあるときに発表される指定河川洪水予報について表示しており、中小河川の洪水危険度とあわせて確認することができます。<br /><br />
            ■ 洪水キキクル（洪水警報の危険度分布）の色が持つ意味<br />
            色が持つ意味やそれに応じた住民等の行動の例については、下の表のとおりです。「災害切迫」（黒）が出現した場合には、重大な洪水災害が切迫しているか、すでに発生している可能性が高い状況となります。このため、遅くとも「危険」（紫）が出現した時点で、河川の水位の情報等を確認し、速やかに避難開始を判断することが重要です。
            <br /><br />
            <v-img
              :src="kouzuiImage"
              @click="openImage(kouzuiImage)"
              contain
              key="kouzuiimage"
            /><br />
            <div class="text-right">出典：気象庁ホームページ</div>
          </div>
        </v-card>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close()">
          閉じる
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "GlossaryDialog",
  props: {
    dialog: {
      type: Boolean
    }
  },
  data() {
    return {
      targetDialog: false,
      tab: "manhole",
      manholeImage: require("@/assets/images/png/glossary-manhole.png"),
      suijinImage1: require("@/assets/images/png/glossary-suijin1.png"),
      suijinImage2: require("@/assets/images/png/glossary-suijin2.png"),
      dosyaImage: require("@/assets/images/png/glossary-dosya.png"),
      kouzuiImage: require("@/assets/images/png/glossary-kouzui.png")
    };
  },
  computed: {
    tabItems() {
      const arr = [];
      arr.push({ tab: "manhole", name: "マンホール水位" });
      arr.push({ tab: "suijin", name: "浸水センサ" });
      arr.push({ tab: "rain", name: "予測雨量" });
      arr.push({ tab: "riverFlooding", name: "内水リスク" });
      arr.push({ tab: "dosya", name: "土砂キキクル" });
      arr.push({ tab: "kouzui", name: "洪水キキクル" });
      return arr;
    }
  },
  watch: {
    dialog(val) {
      this.targetDialog = val;
    },
    tab() {
      this.$refs.dialogContent.scrollTop = 0;
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    openImage(url) {
      window.open(`image.html?url=${url}`);
    }
  }
};
</script>
